/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningscolumnevent2Inputs */

const en_earningscolumnevent2 = /** @type {(inputs: Earningscolumnevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const de_earningscolumnevent2 = /** @type {(inputs: Earningscolumnevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

/**
* | output |
* | --- |
* | "Event" |
*
* @param {Earningscolumnevent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningscolumnevent2 = /** @type {((inputs?: Earningscolumnevent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningscolumnevent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningscolumnevent2(inputs)
	return de_earningscolumnevent2(inputs)
});
export { earningscolumnevent2 as "earningsColumnEvent" }